import axios from '@/axios';

export default {
  fetchAdmins(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          '/api/v1/admins/adminDetails?page=' +
          data.page +
          '&limit=' +
          data.limit +
          '&search=' +
          encodeURIComponent(data.search) +
          '&sort=' +
          data.sort +
          '&dir=' +
          data.dir +
          '&userType=' +
          data.userType
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchAllAdmins() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/admins/allAdmins')
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchAdminDetails(_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/admins/adminDetails/' + id)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateAdminDetails(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/admins/adminDetails/update/' + data.id, data.info)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  saveAdmin(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/register', data.info)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  saveNewAdmin(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/admins/create', data.info)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  deleteAdmin(_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete('/api/v1/deleteUser/' + id)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  checkEditEmail(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/admins/checkEmailForEdit', data)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  changeProfileImage(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/admins/uploadImage', data)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  resetAdminPassword(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/admins/user/' + data.id + '/resetPassword', data.data)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  },
  getSuperAdminDashboardData() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/admins/superAdminDashboardData')
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getSafetyVideoDetail() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/admins/getSafetyVideo')
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateSafetyVideo(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/admins/updateSafetyVideo', data)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  },
  uploadSafetyVideo(_context, video) {
    const data = new FormData();
    data.append('uploadVideo', video);
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/admins/uploadSafetyVideo', data, {
          // @ts-ignore
          header: {
            'Content-Type': 'image/png',
          },
        })
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  },
  deleteSafetyVideo(_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/admins/removeSafetyVideo/' + id)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getSettings() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/admins/getSettings')
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  saveSettings(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/admins/saveSettings', data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchUserPermission(_context, data) {
    return new Promise((resolve, reject) => {
      let url = `/api/v1/admins/user-permission?userId=${data.userId}`;

      if (data.organizationId) {
        url += `&organizationId=${data.organizationId}`;
      }

      axios
        .get(url)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateUserPermission(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .put('/api/v1/admins/user-permission', data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  checkPOSEnabledClinicsFromOrg(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/admins/checkPOSEnabledClinics?organizationId=' + data.organizationId)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  sortCategoryProductList(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/admins/category/sortCategoryProductList', data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  sortBrandProductList(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/admins/brand/sortProductList', data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchAftercareTemplateList() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/admins/aftercaretemplate')
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getSettingsByKey(_context, key) {
    let data;

    if (typeof key === 'object') {
      data = new URLSearchParams(key).toString();
    } else {
      data = `key=${key}`;
    }

    return new Promise((resolve, reject) => {
      axios
        .get(`/api/v1/admins/getSettingsByKey?${data}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateSettingsByKey(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/admins/settings', data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchOversightDoctors(_context, data) {
    return axios.get(
      '/api/v1/admins/doctor-oversights',
      { params: data }
    );
  },
  assignOversightDoctors(_context, data) {
    return axios.post(`/api/v1/admins/doctor-oversights/${data.clinicId}/assignment`, data.body);
  },
  listAssignedOversightDoctors(_context, data) {
    return axios.get(`/api/v1/admins/doctor-oversights/${data.clinicId}/assignment`);
  },
};
